import { useNavigate, useParams, Link } from 'react-router-dom';
import Loading from '../components/Loading';
import { get } from '../lib/Api';
import Linkify from '~/components/Linkify';
import { formatDateTime } from '~/lib/DateTime.js';
import { useQuery } from '@tanstack/react-query';
import AssistantMessage from '~/components/assistant/AssistantMessage.jsx';

function useBackgroundTasksQuery() {
    return useQuery({
        queryKey: ['admin-tasks'],
        queryFn: () => get('/api/admin/background-tasks'),
    });
}

function useBackgroundTaskQuery(taskId) {
    return useQuery({
        queryKey: ['admin-task', taskId],
        queryFn: () => get(`/api/admin/background-tasks/${taskId}`),
        enabled: !!taskId,
    });
}

const TaskDetails = ({ task }) => {
    const navigate = useNavigate();
    const displayMessages = task.results || [];

    return (
        <div>
            {task.business_id && (
                <a
                    href={`/admin/impersonate/${task.business_id}`}
                    target="_blank"
                    className="btn-inverse-pill !no-underline bg-white mb-6 fixed left-36 top-4"
                >
                    Impersonate
                </a>
            )}

            <div
                className={`bg-white shadow-xl rounded-2xl mt-8 p-6  assistant-chatbox transition-all duration-300`}
            >
                {displayMessages.map((message, idx) => (
                    <AssistantMessage
                        key={idx}
                        message={message}
                        className={null}
                        messages={displayMessages}
                        isLastMessage={idx === displayMessages.length - 1}
                        onToolResponse={() => null}
                        isRunning={false}
                    />
                ))}
            </div>

            <div className="panel-label mt-6">Raw Task Details</div>
            <div className="panel">
                <div className="whitespace-pre-wrap">
                    <Linkify>{JSON.stringify(task, null, 2)}</Linkify>
                </div>
            </div>
        </div>
    );
};

const TaskList = ({ backgroundTasks }) => {
    return (
        <div>
            <div className="panel-label">Recent Tasks</div>
            <div className="panel">
                <div className="divide-y">
                    {backgroundTasks.map(task => (
                        <div key={task.id} className="py-3 px-4">
                            <div
                                key={task.id}
                                className="flex items-center justify-between"
                            >
                                <div>
                                    [{task.user_id}]{' '}
                                    {formatDateTime(task.created_at)} (
                                    {task.status})
                                </div>
                                <Link
                                    to={`/admin/tasks/${task.id}`}
                                    className="text-blue-600 hover:text-blue-800"
                                >
                                    View &raquo;
                                </Link>
                            </div>
                            <div className="text-gray-500 text-sm">
                                {task.results[1]?.content}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const AdminBackgroundTasks = ({}) => {
    const { taskId } = useParams();
    const navigate = useNavigate();
    const { data, isLoading } = useBackgroundTasksQuery();
    const { data: selectedTask, isLoading: isLoadingTask } = useBackgroundTaskQuery(taskId);

    return (
        <div className="flex justify-center px-4">
            {!taskId && (
                <div>
                    {isLoading && <Loading />}
                    <TaskList
                        backgroundTasks={(data || []).filter(t =>
                            Array.isArray(t.results),
                        )}
                    />
                </div>
            )}
            {!!taskId && (
                <div className="pt-8">
                    <button
                        onClick={() => navigate('/admin/tasks')}
                        className="btn-pill mb-6 fixed left-8 top-4"
                    >
                        &laquo; Back
                    </button>
                    {isLoadingTask && <Loading />}
                    {selectedTask && <TaskDetails task={selectedTask} />}
                </div>
            )}
        </div>
    );
};

export default AdminBackgroundTasks;
